// import Cookies from 'js-cookie';
import { appNetworkManager } from './network-manager';

export const getExpertise = () => appNetworkManager.get('/get_expertise');
export const getDoctorsInExpertise = (expertiseId: number, page: number) => {
  return appNetworkManager.post(
    '/get_doctors_in_expertise',
    { expertise_id: expertiseId, page },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
export const getSuggestedDoctors = (endVertexId: number, productId: number, page: number) => {
  return appNetworkManager.post(
    '/doctor_suggestion',
    { product_id: productId, end_vertex_id: endVertexId, page },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
export const getExaminationList = (page: number) => {
  return appNetworkManager.get(`/get_all_save_diagnosis?page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postSaveDiagnosis = (payload: any) => {
  return appNetworkManager.post(`/save_diagnosis`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
};
export const getDiagnoseDetail = (id: number) => {
  return appNetworkManager.post(
    `/saved_diagnosis_detail`,
    { saved_diagnosis_id: id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
export const getMyVisitTimes = (date: string) => {
  return appNetworkManager.post(
    `/get_my_visit_times`,
    { visit_date: date },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
export const getDoctor = (id: number) => {
  return appNetworkManager.post(
    `/get_doctor_profile`,
    { doctor_id: id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
export const getDoctorVisitTimes = (id: number, date: string) => {
  return appNetworkManager.post(
    `/get_doctors_visit_time`,
    {
      target_doctor_id: id,
      req_visit_date: date
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};
